import { render, staticRenderFns } from "./ChatQueueSettings.vue?vue&type=template&id=50a2cf98&"
import script from "./ChatQueueSettings.vue?vue&type=script&lang=ts&"
export * from "./ChatQueueSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports